import React from 'react';
import { DisconnectedIntegrationModalBody } from '../DisconnectedIntegrationModalBody';

interface PropTypes {
  url: string;
  onClose: () => void;
  largeImage?: boolean;
}

export function ReconnectEmailIntegrationModalBody(props: PropTypes) {
  return (
    <DisconnectedIntegrationModalBody
      largeImage={props.largeImage}
      url={props.url}
      onClose={props.onClose}
      informationText='For security reasons your email integration is expired'
      actionText={
        <>
          Reconnect the email integration in your user settings <br></br>
          to continue sending and receiving emails.
        </>
      }
    />
  );
}
